export default __webpack_public_path__ + "static/media/Looper.fd3d079e.jpg";